import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';

export const HeroSection = () => {
  return (
    <section className="hero-section">
      {/* Layer 1: Background Video */}
      <video 
        className="hero-video-background"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/videos/dovira-hero.mp4" type="video/mp4" />
      </video>

      {/* Layer 2a: Dark red overlay for readability */}
      <div className="hero-overlay-dark"></div>

      {/* Layer 2b: Decorative pattern overlay */}
      <div className="hero-pattern-overlay"></div>

      {/* Layer 3: Content */}
      <div className="hero-container">
        <div className="hero-content-cinematic">
          <h1 className="hero-title-cinematic">
            {siteConfig.companyFullName}
          </h1>
          <p className="hero-subtitle-cinematic">
            {siteConfig.tagline}
          </p>
          <div className="hero-buttons-cinematic">
            <Link to="/catalog" className="hero-button-cinematic hero-button-primary-cinematic">
              Переглянути каталог
              <ArrowRight size={20} />
            </Link>
            <a href="#contacts" className="hero-button-cinematic hero-button-secondary-cinematic">
              <Phone size={20} />
              Зв'язатися з нами
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

